<template>
    <div>
        <card-header title="Pending Letters" icon="fa-envelope"/>

        <card-body>
            <card-list>
                <template v-if="currentUser.role === 'dev' || currentUser.role === 'admin'">
                    <subheader-list-item title="Pending Letters (PostGrid)" icon="fa-envelope" :badge="pendingLetters.length"/>
                    <pending-letter
                        v-for="plan in pendingLetters"
                        :card="card"
                        :plan="plan"
                        :active="child && child.definition.component === 'payment-plan' && parseInt(child.props.planId) === plan.id"
                        @click="$openCard('payment-plan', {planId: plan.id}, card)"
                    />
                </template>


            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import PlanTile from "@/components/tiles/PlanTile";

    import {client as http} from '../../http_client';
    import {mapGetters} from "vuex";
    import PendingLetter from "../../components/tiles/PendingLetter.vue";

    export default {
        components: {PendingLetter, PlanTile, CardHeader, CardBody, CardToolbar, CardList, SubheaderListItem},
        props: ['card', 'child'],
        data() {
            return {
                pendingLetters: []
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            loadPlans: function (force) {
                this.$emit('loading', true);

                http.get('payment-plans/pending-letters', {force}).then(response => {
                    this.pendingLetters = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function () {
                this.loadPlans(true);
            }
        },
        mounted: function () {
            this.loadPlans();
        }
    }
</script>
